import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

import {
  FinancesPeriod,
  getPeriodLabel,
  isAtOrAfterToday,
  nextPeriodDate,
  prevPeriodDate,
} from '../../../utils/financesUtils';

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
`;

const ChevronButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${(props) => props.theme.colors.primary};
  padding: 4px 8px;
  font-size: 16px;
  display: flex;
  align-items: center;

  &:disabled {
    opacity: 0.3;
    cursor: default;
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.primary};
    outline-offset: 2px;
  }
`;

const Label = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.colors.dark};
`;

interface DateNavigatorProps {
  anchorDate: Date;
  period: FinancesPeriod;
  onNavigate: (date: Date) => void;
}

const DateNavigator = ({ anchorDate, period, onNavigate }: DateNavigatorProps) => {
  const atOrAfterToday = isAtOrAfterToday(anchorDate, period);

  return (
    <Row>
      <ChevronButton aria-label="Previous period" onClick={() => onNavigate(prevPeriodDate(anchorDate, period))}>
        <FontAwesomeIcon icon={faChevronLeft} />
      </ChevronButton>
      <Label>{getPeriodLabel(anchorDate, period)}</Label>
      <ChevronButton
        aria-label="Next period"
        disabled={atOrAfterToday}
        onClick={() => onNavigate(nextPeriodDate(anchorDate, period))}
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </ChevronButton>
    </Row>
  );
};

export default DateNavigator;
